import i18n from "i18next";
import { type FC } from "react";

interface CreateTablePlaceholderComponentProps {
    messageKey?: string;
}

export const CreateTablePlaceholderComponent: FC<CreateTablePlaceholderComponentProps> = ({
    messageKey = "table.editForm.placeholder",
}) => {
    return <>{i18n.t(messageKey)}</>;
};
